import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=0041d87e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0041d87e')) {
      api.createRecord('0041d87e', component.options)
    } else {
      api.reload('0041d87e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=0041d87e&", function () {
      api.rerender('0041d87e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Jtg3pW3u5L6q/JS/videoIframe.vue"
export default component.exports